import { useEffect, useState } from "react";

const useMemberJoined = ({ channelInformation }) => {
  const [member, setMember] = useState();
  useEffect(() => {
    if (channelInformation !== undefined) {
      channelInformation.on("participantJoined", (member) => {
        setMember(member);
      });
    }
    //eslint-disable-next-line
  }, [channelInformation]);

  return { member };
};

export default useMemberJoined;
